@file:OptIn(InternalResourceApi::class)

package inspection.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/inspection.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_141_969_530)
internal val Res.font.Manrope_Bold: FontResource by lazy {
      FontResource("font:Manrope_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/Manrope-Bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-275_329_905)
internal val Res.font.Manrope_Regular: FontResource by lazy {
      FontResource("font:Manrope_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/Manrope-Regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Manrope_Bold", Res.font.Manrope_Bold)
  map.put("Manrope_Regular", Res.font.Manrope_Regular)
}
